if (!customElements.get("navigation-drawer")) {
  class NavigationDrawer extends HTMLElement {
    constructor() {
      super();
      this.isAnimating = false;
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(e) {
      const button = e.target.closest(".menu-drawer__button");
      if (!button) return;

      const menuItem = button.closest("li.menu-drawer__item");
      const submenu = menuItem?.querySelector(
        ":scope > .menu-drawer__nested-menu"
      );

      if (!menuItem || !submenu) return;

      e.preventDefault();
      this.toggleSubmenu(menuItem, submenu);
    }

    toggleSubmenu(menuItem, submenu) {
      if (this.isAnimating) return;

      const isActive = menuItem.classList.contains("menu-drawer__item-active");
      this.isAnimating = true;

      this.closeSiblings(menuItem);

      if (isActive) {
        this.closeSubmenu(menuItem, submenu);
      } else {
        this.openSubmenu(menuItem, submenu);
      }
    }

    closeSiblings(menuItem) {
      const parent = menuItem.parentElement;
      const siblings = parent.children;

      for (let i = 0; i < siblings.length; i++) {
        const sibling = siblings[i];
        if (
          sibling !== menuItem &&
          sibling.classList.contains("menu-drawer__item")
        ) {
          const siblingSubmenu = sibling.querySelector(
            ":scope > .menu-drawer__nested-menu"
          );
          if (
            siblingSubmenu &&
            sibling.classList.contains("menu-drawer__item-active")
          ) {
            this.closeSubmenu(sibling, siblingSubmenu);
          }
        }
      }
    }

    openSubmenu(menuItem) {
      menuItem.classList.add("menu-drawer__item-active");

      setTimeout(() => {
        this.isAnimating = false;
      }, 300);
    }

    closeSubmenu(menuItem) {
      menuItem.classList.remove("menu-drawer__item-active");

      setTimeout(() => {
        this.isAnimating = false;
      }, 300);
    }
  }

  customElements.define("navigation-drawer", NavigationDrawer);
}
